module.exports = __webpack_public_path__ + "img/talent-concept.cd590a36.png";